import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportPaymentComponent } from './import-payment.component';


const routes: Routes = [
  {
    path: '',
    component: ImportPaymentComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImportPaymentRoutingModule { }
